// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__26-v8","errors":"Errors_errors__W4-zQ"};